// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"997":"ef67dadb","6456":"c9c24d25","7731":"59f96b2c","8528":"a4a248fc","9330":"aa48a2d2"}[chunkId] + ".chunk.css";
};